export default "__VITE_ASSET__1bde8966__"